import { useQuery } from '@tanstack/react-query';

import { UserSegment } from '~/types/userSegment';

import { model } from '../';

export const queryKey = ['userSegments'];

export const useUserSegments = () => useQuery<UserSegment[]>(queryKey, () => model.userSegments());
